import React, { useState, useEffect } from "react";
import Header from "./components/Header";
import Hero from "./components/Profile";
import Portfolio from "./components/Portofolio";
import Contact from "./components/Contact";
import WorkExperience from "./components/WorkExperience";
import Footer from "./components/Footer";
import Loading from "./components/Loading";
import Education from "./components/Education";
import Background from "./components/Background";
// Removed direct font import as it's in index.css

const App: React.FC = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  return isLoading ? (
    <Loading />
  ) : (
    <div className="font-poppins antialiased min-h-screen relative text-gray-200 selection:bg-accent selection:text-white">
      <Background />
      <div className="relative z-10 w-full">
        <Header />
        <main className="w-full relative">
          <Hero />
          <WorkExperience />
          <Portfolio />
          <Education />
          <Contact />
        </main>
        <Footer />
      </div>
    </div>
  );
};

export default App;
